import React from "react";
import { Member } from "@Src/constants/";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useSelector } from "react-redux";
import { selectors } from "@ReduxStore/reducers";

const { REGISTER_WITH_CODE } = Member;

const Captcha = ({ onVerify, doReveal = true }) => {
  const language = useSelector(selectors.getLanguageSelector);
  const registrationType = useSelector(selectors.getRegistrationType);

  if (registrationType !== REGISTER_WITH_CODE) return null;
  return (
    <div
      className={`SignUp-form_hcaptcha ${doReveal ? "reveal" : ""}`}
      data-testid="captcha-challenge"
    >
      <HCaptcha sitekey="dd0ef89c-c742-4212-9702-df0c919c3c6e" onVerify={onVerify} hl={language} />
    </div>
  );
};

export default Captcha;
